import { connect } from "@formily/react";
import { NumberPicker as AntNumerPicker } from "@formily/antd-v5";

export const NumberPicker = connect((props) => {
  const enhancedProps = {
    ...props,
    inputMode: props.inputMode || "numeric", // Default to 'numeric' input mode
  };

  return <AntNumerPicker {...enhancedProps} />;
});
